import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { RouteService } from 'src/app/core/services/route.service';
import { Select2Data } from 'src/app/core/state/_models/general.model';
import { getLookupFields } from 'src/app/core/state/_selectors/field.selector';

@Component({
  selector: 'app-multi-field-selector',
  templateUrl: './multi-field-selector.component.html',
  styleUrls: ['./multi-field-selector.component.scss'],
})
export class MultiFieldSelectorComponent implements OnInit {
  @Input('populate') populate: Array<any> = [];
  @Input('fields') fields: Array<Select2Data> | null = null;
  @Input('fieldName') fieldName!: string;
  @Input('booleanField') booleanField!: string;
  @Input('title') title: string | null = null;
  @Output('selected') selected = new EventEmitter<UntypedFormArray>();
  form!: UntypedFormArray;

  constructor(private fb: UntypedFormBuilder, private modal: NgbModal) {}

  ngOnInit(): void {
    this.initForm();
    this.populateData();
    this.resetFieldDisabled();
  }

  populateData = () => {
    this.populate.forEach((data) => {
      if(Object.keys(data).includes(this.booleanField)){
        this.addField(data[this.fieldName],data[this.booleanField]);
      } else {
        this.addField(data[this.fieldName]);
      }
    });
  };

  /**
   * Form
   */
  initForm = () => {
    this.form = this.fb.array([]);
    if (!this.populate.length) this.addField();
  };

  getFormGroup = (group: any) => group as UntypedFormGroup;

  /**
   * Add field to form array
   */
  addField = (fieldData: string = '', boolValue:boolean = true) => {
    if(!this.booleanField){
      this.form.push(
        this.fb.group({
          [this.fieldName]: [fieldData ? fieldData : null, Validators.required],
        })
      );
    } else {
      this.form.push(
        this.fb.group({
          [this.fieldName]: [fieldData ? fieldData : null, Validators.required],
          [this.booleanField]: [boolValue],
        })
      );
    }
  };

  /**
   * Remove field from form array
   * @param index index of element
   */
  removeField = (index: number) => {
    this.form.removeAt(index);
    this.fieldSelected()
  };

  close = () => {
    // this.selected.emit(this.form);
    this.modal.dismissAll();
  };

  /**
   * On save click
   */
  onSave = () => {
    this.selected.emit(this.form);
    this.close();
  };

  /**
   * On field select
   */
  fieldSelected(){
    this.resetFieldDisabled();
    this.form.value.forEach((data:any)=>{
      const fieldIndex = this.fields?.findIndex((field:any)=> field.value === data[this.fieldName])
      if(fieldIndex !== undefined && fieldIndex > -1 && this.fields?.length){
        this.fields[fieldIndex].disabled = true;
      }
    })
  }

  resetFieldDisabled(){
    this.fields?.forEach((field:any)=>{
      field.disabled = false;
    })
  }
}
